export const FONT_FAMILY_TYPE = {
  NANUM_GOTHIC: `'Nanum Gothic', sans-serif`,
  NANUM_MYEONGJO: `'Nanum Myeongjo', serif`,
  NOTO_SERIF: `'Noto Serif KR', serif`,
  NOTO_SANS: `'Noto Sans KR', sans-serif`,
  PRENTENDARD: `'Pretendard', 'Roboto','Apple SD Gothic Neo',
'Noto Sans KR', sans-serif`,
  PRENTENDARD_JP: `'Pretendard JP Variable', 'Pretendard JP', Pretendard,
      -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue',
      'Segoe UI', 'Hiragino Sans', 'Apple SD Gothic Neo', Meiryo, 'Noto Sans JP',
      'Noto Sans KR', 'Malgun Gothic', Osaka, 'Apple Color Emoji',
      'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif`,
  SHRIKHAHND: `'Shrikhand', 'Binggrae-Bold', serif`,
  HEIROFLIGHT: `'HeirofLight', 'IM Fell French Canon SC', 'Nanum Myeongjo', serif`,
  CHOSUNILBO: `'Chosunilbo_myungjo', 'Nanum Myeongjo',serif`,
  WARHAVEN: `'Warhaven', 'Noto Sans KR', sans-serif`,
  RIDIBATANG: `'RIDIBatang', 'Nanum Myeongjo',serif`,
  D2CODING: `'D2Coding', 'Pretendard', 'Noto Sans KR',sans-serif`,
  LATO: `'Lato','Noto Sans KR', sans-serif`,
  CAUDEX: `'Caudex', 'Nanum Myeongjo', serif`,
  CINZEL: `'Cinzel', 'Nanum Myeongjo',serif`,
  IM_FELL_FRENCH: `'IM Fell French Canon SC', 'Nanum Myeongjo',serif`,
  ACTA_DISPLAY: `'Acta Display', 'Nanum Myeongjo', serif`,
  OXANIUM: `'Oxanium', 'Noto Sans KR', sans-serif`,
  GMARKETLIGHT: `'GmarketSansLight', 'Noto Sans KR', sans-serif`,
  GMARKETBOLD: `'GmarketSansBold', 'Noto Sans KR', sans-serif`,
  CHOSUNSM: `'ChosunSm', 'Noto Sans KR', sans-serif`,
  GONGGOTHIC: `'GongGothic', 'Noto Sans KR', sans-serif`,
  MABINOGICLASSIC: `'MabinogiClassic', 'Noto Sans KR', sans-serif`,
  CHOSUNGU: `'ChosunGu', 'Noto Sans KR', sans-serif`,
  DUNGGEUNMO: `'DungGeunMo', monospace, sans-serif`,
  GALMURI9: `'Galmuri9', monospace, sans-serif`,
  GALMURI11: `'Galmuri11', monospace, sans-serif`,
  AGOTHIC: `'Agothic', monospace, sans-serif`,
  OHSQUAREAIR: `'Cafe24OhsquareAir', monospace, sans-serif`,
  MAPLESTORY_BOLD: `'MaplestoryOTFBold', 'Noto Sans KR', sans-serif`,
  SPACE_MONO: `'Space Mono', monospace`,
} as const;

export type FONT_FAMILY_TYPE_KEY = keyof typeof FONT_FAMILY_TYPE;
export type FONT_FAMILY_TYPE_VALUE =
  typeof FONT_FAMILY_TYPE[FONT_FAMILY_TYPE_KEY];

export const FONT_FAMILY_MAP = {
  [FONT_FAMILY_TYPE.NANUM_GOTHIC]: '나눔고딕',
  [FONT_FAMILY_TYPE.NANUM_MYEONGJO]: '나눔명조',
  [FONT_FAMILY_TYPE.NOTO_SANS]: '노토산스 - 산셰리프',
  [FONT_FAMILY_TYPE.NOTO_SERIF]: '노토산스 - 셰리프',
  [FONT_FAMILY_TYPE.PRENTENDARD]: 'Pretendard',
  [FONT_FAMILY_TYPE.PRENTENDARD_JP]: 'Pretendard-JP',
  [FONT_FAMILY_TYPE.AGOTHIC]: 'a고딕',
  [FONT_FAMILY_TYPE.SHRIKHAHND]: 'Shrikhand & 빙그레',
  [FONT_FAMILY_TYPE.HEIROFLIGHT]: '빛의 계승자',
  [FONT_FAMILY_TYPE.CHOSUNILBO]: '조선일보명조',
  [FONT_FAMILY_TYPE.WARHAVEN]: '넥슨 워헤이븐',
  [FONT_FAMILY_TYPE.MAPLESTORY_BOLD]: '넥슨 메이플스토리',
  [FONT_FAMILY_TYPE.RIDIBATANG]: '리디바탕',
  [FONT_FAMILY_TYPE.D2CODING]: 'D2Coding',
  [FONT_FAMILY_TYPE.GMARKETLIGHT]: 'G마켓-light',
  [FONT_FAMILY_TYPE.GMARKETBOLD]: 'G마켓-bold',
  [FONT_FAMILY_TYPE.CHOSUNSM]: '조선신명조',
  [FONT_FAMILY_TYPE.GONGGOTHIC]: '이사만루',
  [FONT_FAMILY_TYPE.MABINOGICLASSIC]: '마비옛체',
  [FONT_FAMILY_TYPE.CHOSUNGU]: '조선굴림체',
  [FONT_FAMILY_TYPE.OHSQUAREAIR]: '카페24 아네모네 에어',
  [FONT_FAMILY_TYPE.DUNGGEUNMO]: '둥근모꼴',
  [FONT_FAMILY_TYPE.GALMURI9]: '갈무리9',
  [FONT_FAMILY_TYPE.GALMURI11]: '갈무리11',
  [FONT_FAMILY_TYPE.LATO]: 'Lato (영문용)',
  [FONT_FAMILY_TYPE.CAUDEX]: 'Caudex (영문용)',
  [FONT_FAMILY_TYPE.CINZEL]: 'Cinzel (영문용)',
  [FONT_FAMILY_TYPE.IM_FELL_FRENCH]: 'IM Fell French Canon SC (영문용)',
  [FONT_FAMILY_TYPE.ACTA_DISPLAY]: 'Acta Display (영문용)',
  [FONT_FAMILY_TYPE.OXANIUM]: 'Oxanium (영문용)',
  [FONT_FAMILY_TYPE.SPACE_MONO]: 'Space Mono (영문용)',
};

export const customFontList = Object.keys(FONT_FAMILY_MAP).map((key) => {
  return {
    key: key,
    value: FONT_FAMILY_MAP[key],
  };
});
